import { useMutation } from '@tanstack/react-query'
import { useUserContext } from '../context'
import { mutation } from '../graphql'

export const useUpdateSpaceMutation = () => {
  const { refetchActiveSpace } = useUserContext()

  return useMutation({
    mutationFn: async (input) => {
      return await mutation({ mutation: 'updateSpace', input })
    },
    onSuccess: () => {
      refetchActiveSpace()
    }
  })
}
